import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { MarketView } from "../../../_app/types";
import CustomPaper from "../../../_components/CustomPaper";
import IconComponent from "../../../components/ui/IconComponent";
import AdronTypography from "../../../_components/AdronTypography";

interface Props {
  market: MarketView;
}

const Market = ({ market }: Props) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const connectPage = (market: string) => navigate(`/account/connect/${market}`);

  return (
    <CustomPaper
      sx={{ opacity: 1 }}
      onClick={() => connectPage(market.name)}
      color={theme.palette.grey[400]}
    >
      <Stack direction={"row"} sx={{ width: "100%" }} spacing={2} alignItems={"center"}>
        <IconComponent iconName={market.name} size={40} type={"asBackground"} />
        <AdronTypography style={{ fontWeight: 600 }} fontSize={14} value={market.displayedName} />
      </Stack>
    </CustomPaper>
  );
};

export default Market;
